import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AccountingProvider } from "./pages/components/context/AccountingContext.jsx";

// Pages
import SalesHome from "./pages/SalesHome.jsx";
import SalesTransactions from "./pages/SalesTransactions.jsx";
import TransactionEditor from "./pages/TransactionEditor.jsx";
import SalesInvoices from "./pages/SalesInvoices.jsx";
import SalesBilling from "./pages/SalesBilling.jsx";
import AccessLogs from "./pages/AccessLogs.jsx";
import LogicalPlugins from "./pages/LogicalPlugins.jsx";
import SalesCenter from "./pages/SalesCenter.jsx";
import ReceiveOrder from "./pages/ReceiveOrder.jsx";

function App() {
  return (
    <BrowserRouter>
      <AccountingProvider>
        <Routes>
          {/* Default route */}
          <Route path="/" element={<SalesHome />} />
          
          {/* Sales routes */}
          <Route path="/sales" element={<SalesHome />} />
          <Route path="/sales/transactions" element={<SalesTransactions />} />
          <Route path="/sales/transactions/:id" element={<TransactionEditor />} />
          <Route path="/sales/invoices" element={<SalesInvoices />} />
          <Route path="/sales/billing" element={<SalesBilling />} />
          <Route path="/access-logs" element={<AccessLogs />} />
          
          {/* Logical Canvas routes */}
          <Route path="/logical-canvas" element={<LogicalPlugins />} />
          <Route path="/logical-plugins" element={<Navigate to="/logical-canvas" replace />} />
          <Route path="/sales-center" element={<SalesCenter />} />
          <Route path="/receive-order" element={<ReceiveOrder />} />
          
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AccountingProvider>
    </BrowserRouter>
  );
}

export default App;
